import script from "./PublicationsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicationsPage.vue?vue&type=script&setup=true&lang=js"

import "./PublicationsPage.vue?vue&type=style&index=0&id=9c5f294c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c5f294c"]])

export default __exports__